if (!customElements.get('search-redirect')) {
  class SearchRedirect extends HTMLElement {
    constructor() {
      super();
      this.forms = document.querySelectorAll('form[action="/search"]');
      this.forms.forEach((form) => {
        form.addEventListener('submit', () => this.handleSearchInput(form));
      });
    }

    handleSearchInput(form) {
      const searchValue = form.querySelector('input[type="search"]').value.toLowerCase().trim();
      const collectionRedirects = JSON.parse(window.sessionStorage.getItem('collection_redirects'));
      const redirect = collectionRedirects.find(
        (redirect) => redirect.query_text.toLowerCase() === searchValue
      )?.redirect;

      if (redirect) {
        event.preventDefault();
        window.location.href = redirect + '?filter.v.availability=1';
      }
    }
  }

  window.SearchRedirect = SearchRedirect;

  customElements.define('search-redirect', SearchRedirect);
}
